const urls = [
  // {
  //   url: '/',
  //   title: 'other_v1_2_2_CryptoTradingPlatform',
  //   description: 'other_v1_2_2_HotcoinIsACryptocurrency',
  //   keywords: 'other_v1_2_2_cryptotrading',
  // },
  /* {
    url: '/login',
    title: 'other_v1_2_2_login',
    description: 'other_v1_2_2_LoginToHotcoin',
    keywords: 'other_v1_2_2_welcometologin',
    group: 'auth',
  }, */
  /* {
    url: '/register',
    title: 'other_v1_2_2_register',
    description: 'other_v1_2_2_JoinHotcoin',
    keywords: 'other_v1_2_2_registerhotcoin',
  }, */
  { url: '/retrieve' },
  { url: '/bindAccount' },
  { url: '/safetyItems' },
  { url: '/user/personSetting/userBindAccount' },
  { url: '/order/subscribeOrder' },
  {
    url: '/status',
    title: 'other_v1_2_2_SystemStatusHotcoin',
    description: 'other_v1_2_2_StayInformedWithOur',
    keywords: 'other_v1_2_2_SystemStatus',
  },
  // {
  //   url: '/app/downLoad',
  //   title: 'other_v1_2_2_app',
  //   description: 'other_v1_2_2_appdownLoad',
  //   keywords: 'other_v1_2_2_downLoad',
  // },
  {
    url: '/desktop',
    title: 'other_v1_2_2_EnjoyTradingWithHotcoin',
    description: 'other_v1_2_2_HotcoinTradeOnThe',
    keywords: 'other_v1_2_2_desktop',
  },
  {
    url: '/position',
    title: 'other_v1_2_2_CareerOpportunitiesHotcoin',
    description: 'other_v1_2_2_LaunchYourCryptoCareer',
    keywords: 'other_v1_2_2_position',
  },
  {
    url: '/position/detail/[code]',
    title: 'other_v1_2_2_CareerOpportunities',
    description: 'other_v1_2_2_ExploreExcitingCareerOpportunitiesAtHotcoin',
    keywords: 'other_v1_2_2_CareerOpportunitiesAtHotcoin',
  },
  {
    url: '/rateStandard',
    title: 'other_v1_2_2_CryptocurrencyRateStandard',
    description: 'other_v1_2_2_AccessTheCryptocurrencyRate',
    keywords: 'other_v1_2_2_cryptocurrencyrate',
  },
  // {
  //   url: '/coinInfo',
  //   title: 'other_v1_2_2_CryptoDetailsHotcoin',
  //   description: 'other_v1_2_2_ExploreTheWorldOf',
  //   keywords: 'other_v1_2_2_cryptocurrencytrading',
  // },
  {
    url: '/c2c',
    title: 'other_v1_2_2_C2CTrading',
    description: 'other_v1_2_2_ExploreHotcoinC2C',
    keywords: 'other_v1_2_2_c2c',
  },
  {
    url: '/c2c/trade',
    title: 'other_v1_2_2_c2ctrade',
    description: 'other_v1_2_2_DiscoverTheTopC2CTradePlatform',
    keywords: 'other_v1_2_2_buycrypto',
  },
  {
    url: '/c2c/order',
    title: 'other_v1_2_2_BestPlaceToBuy',
    description: 'other_v1_2_2_DiscoverTheTopC2C',
    keywords: 'other_v1_2_2_trade',
  },
  {
    url: '/c2c/order/detail',
    title: 'other_v1_2_2_C2COrderDetails',
    description: 'other_v1_2_2_TradeEasilyWithHotcoin',
    keywords: 'other_v1_2_2_C2COrder',
  },
  { url: '/c2c/adManagement' },
  {
    url: '/c2c/details',
    title: 'other_v1_2_2_C2CTradingDetails',
    description: 'other_v1_2_2_HotcoinACryptoTradingPlatform',
    keywords: 'other_v1_2_2_C2CDetails',
  },
  { url: '/c2c/business' },
  { url: '/c2c/merchantapply' },
  { url: '/c2c/advertise' },
  {
    url: '/c2c/paymentSettings',
    title: 'other_v1_2_2_C2CPaymentSetting',
    description: 'other_v1_2_2_CheckOutHotcoinC2CPaymentSetting',
    keywords: 'other_v1_2_2_c2cpaymentsettings',
  },
  { url: '/c2c/account' },
  { url: '/c2c/log' },
  { url: '/c2c/quickTrade/pexpay' },
  { url: '/user' },
  //{ url: '/user/ic' },
  { url: '/user/listOfTalent' },
  { url: '/user/myInvitationList' },
  { url: '/user/overView' },
  { url: '/user/personalPreference' },
  { url: '/user/personSetting' },
  { url: '/user/apiSetting' },
  { url: '/op/index' },
  { url: '/op/lockRecord' },
  { url: '/op/lock' },
  { url: '/op/EarnMoney' },
  { url: '/op/holdDetail' },
  { url: '/op/innovateDetail' },
  { url: '/op/hold' },
  { url: '/op/financingDetail' },
  // { url: '/contract/exchange/[tradeName]' },
  // { url: '/contract/exchange' },
  {
    url: '/contract/position',
    title: 'other_v1_2_2_FuturesInfo',
    description: 'other_v1_2_2_DiscoverFuturesInfoonHotcoin',
    keywords: 'other_v1_2_2_futures',
  },
  { url: '/contract/openAnswer' },
  {
    url: '/contract/invitationCommission',
    title: 'other_v1_2_2_ReferFriendsToJoin',
    description: 'other_v1_2_2_JoinOurReferralProgram',
    keywords: 'other_v1_2_2_earncrypto',
  },
  { url: '/contract/invitationCommission/detail' },
  { url: '/simulation/exchange/[tradeName]' },
  { url: '/simulation/exchange' },
  {
    url: '/simulation/order',
    title: 'other_v1_2_2_FuturesOrderMockTrading',
    description: 'other_v1_2_2_ExploreFuturesTradingWith',
    keywords: 'other_v1_2_2_futurestrading',
  },
  {
    url: '/simulation/account',
    title: 'other_v1_2_2_MockTradingAccount',
    description: 'other_v1_2_2_ExperienceRiskFreeCryptoTrading',
    keywords: 'other_v1_2_2_mocktradinghotcoin',
  },
  {
    url: '/simulation/finance',
    title: 'other_v1_2_2_FinanceLogMockTrading',
    description: 'other_v1_2_2_ExperienceRiskFreeCryptoTradingWithHotcoin',
    keywords: 'other_v1_2_2_financelog',
  },
  {
    url: '/simulation/position',
    title: 'other_v1_2_2_PositionMockTrading',
    description: 'other_v1_2_2_MasterCryptoMockTradingWithHotcoin',
    keywords: 'other_v1_2_2_positionmock',
  },
  // {
  //   url: '/trade/[tradeName]',
  //   title: 'other_v1_2_2_TradeName',
  //   description: 'other_v1_2_2_TradeOnHotcoin',
  //   keywords: 'other_v1_2_2_tradetradename',
  // },
  // {
  //   url: '/trade',
  //   title: 'other_v1_2_2_tradeHotcoin',
  //   description: 'other_v1_2_2_TradeCryptocurrenciesGloballyWithHotcoin',
  //   keywords: 'other_v1_2_2_trade_',
  // },
  {
    url: '/tradePlate',
    title: 'other_v1_2_2_TradePlate',
    description: 'other_v1_2_2_TradePlateAccessA',
    keywords: 'other_v1_2_2_trade_plate',
  },
  { url: '/exchangeETF' },
  {
    url: '/wealthManagement',
    title: 'other_v1_2_2_EarnBitcoinMore',
    description: 'other_v1_2_2_HotcoinOffersFreeCrypto',
    keywords: 'other_v1_2_2_tradingcrypto',
  },
  { url: '/wealthManagementList' },
  { url: '/wealthManagement/timeTreasure' },
  { url: '/wealthManagement/currentTreasure' },
  { url: '/wealthManagement/regularExperience' },
  { url: '/wealthManagement/record' },
  { url: '/wealthManagement/redeem' },
  {
    url: '/pledgeBorrowMoney',
    title: 'other_v1_2_2_CryptoLoansHotcoin',
    description: 'other_v1_2_2_SecureCryptoLoansAvailable',
    keywords: 'other_v1_2_2_cryptoloan',
  },
  { url: '/applyFor' },
  {
    url: '/twoCoinsFinalcial',
    title: 'other_v1_2_2_FuturesDualInvestment',
    description: 'other_v1_2_2_DualInvestmentGivesYou',
    keywords: 'other_v1_2_2_buyandsellcryptocurrency',
  },
  { url: '/twoCoinsFinalcial/open' },
  // {
  //   url: '/market',
  //   title: 'other_v1_2_2_InternationalCryptoMarket',
  //   description: 'other_v1_2_2_CheckOutTheLatest',
  //   keywords: 'other_v1_2_2_cryptomarket',
  // },
  { url: '/market/rankings' },
  { url: '/marketExplore', title: '', description: '', keywords: 'other_v1_2_2_cryptoprice' },

  // {
  //   url: '/support/index',
  //   title: 'other_v1_2_2_HotcoinHelpCenterYour',
  //   description: 'other_v1_2_2_HotcoinHelpCenter',
  //   keywords: 'other_v1_2_2_tradingcryptocurrency',
  // },
  // {
  //   url: '/support/nav',
  //   title: 'other_v1_2_2_HotcoinAnnouncement',
  //   description: 'other_v1_2_2_FindComprehensiveSupportFromHotcoin',
  //   keywords: 'other_v1_2_2_support',
  // },
  // {
  //   url: '/support/article',
  //   title: 'other_v1_2_2_SupportArticles',
  //   description: 'other_v1_2_2_GetTheLatestHotcoinSupportArticles',
  //   keywords: 'other_v1_2_2_article',
  // },
  // { url: '/support/search' },
  // {
  //   url: '/support/notice',
  //   title: 'other_v1_2_2_HotcoinAnnouncements',
  //   description: 'other_v1_2_2_StayUpdatedOnHotcoin',
  //   keywords: 'other_v1_2_2_international_crypto_market',
  // },
  {
    url: '/support/official-channel',
    title: 'other_v1_2_2_HotcoinOfficialChannelVerification',
    description: 'other_v1_2_2_SafeguardAgainstPhishingAnd',
  },
  { url: '/verifiedIndex' },
  { url: '/verifiedResult' },
  { url: '/companyVerifiedType' },
  { url: '/companyVerifiedMaterial' },
  { url: '/companyVerifiedSubmit' },
  { url: '/companyVerifiedDeclare' },
  { url: '/personVerified' },
  { url: '/personVerifiedHighLevel' },
  {
    url: '/margin/open',
    title: 'other_v1_2_2_ActivatedMarginTrade',
    description: 'other_v1_2_2_DiscoverMoreAboutActivatedMarginTrading',
    keywords: 'other_v1_2_2_margintrade',
  },
  {
    url: '/margin/trade/[tradeName]',
    title: 'other_v1_2_2_MarginTradeHotcoin',
    description: 'other_v1_2_2_TradeGlobalCryptocurrencyAssets',
    keywords: 'other_v1_2_2_margin',
  },
  { url: '/margin/trade' },
  { url: '/inMail/noticeList' },
  { url: '/inMail/noticeNavList' },
  {
    url: '/nft',
    title: 'other_v1_2_2_NftHotcoin',
    description: 'other_v1_2_2_UsersAreAbleToPurchaseThe',
    keywords: 'other_v1_2_2_NFT',
  },
  {
    url: '/nft/home',
    title: 'other_v1_2_2_NFTMarketExploreNFT',
    description: 'other_v1_2_2_UsersAreAbleToPurchase',
    keywords: 'other_v1_2_2_NFTmarket',
  },
  {
    url: '/nft/game/detail',
    title: 'other_v1_2_2_NFTGameDetails',
    description: 'other_v1_2_2_HotcoinYourGoToGuideForNFT',
    keywords: 'other_v1_2_2_NftGame',
  },
  {
    url: '/nft/games',
    title: 'other_v1_2_2_NFTGamesHotcoin',
    description: 'other_v1_2_2_RegisterNowAtHotcoinNFTGames',
    keywords: 'other_v1_2_2_nftgames',
  },
  {
    url: '/nft/videos',
    title: 'other_v1_2_2_NFTVideosNFTGames',
    description: 'other_v1_2_2_ExploreHotcoinForUniqueNFTvideos',
    keywords: 'other_v1_2_2_NFTvideos',
  },
  {
    url: '/nft/igo',
    title: 'other_v1_2_2_NFTIGOHotcoin',
    description: 'other_v1_2_2_CheckOutHotcoinNFTIGO',
    keywords: 'other_v1_2_2_NFTIGO',
  },
  {
    url: '/nft/igo/token/detail',
    title: 'other_v1_2_2_NFTIGOToken',
    description: 'other_v1_2_2_ExploreHotcoinNFTIGO',
    keywords: 'other_v1_2_2_NFTIGOToken',
  },
  { url: '/nft/igo/mysterybox/detail' },
  { url: '/nft/asset/regularNft' },
  { url: '/nft/asset/mysteryBoxes' },
  { url: '/nft/asset/orders' },
  { url: '/nft/asset/favorites' },
  { url: '/nft/asset/deposit' },
  { url: '/nft/asset/deposit/contractAddress' },
  { url: '/nft/asset/withdraw' },
  { url: '/nft/asset/withdraw/addressManage' },
  { url: '/nft/asset/detail' },
  { url: '/nft/asset/onsale' },
  { url: '/nft/market' },
  { url: '/nft/market/allProject' },
  { url: '/nft/market/projectDetails' },
  { url: '/nft/market/nftDetails' },
  { url: '/activity/fifthAnniversary', title: 'other_v1_2_2_CelebrateHotcoinGlobal5thAnniversaryTrading' },
  { url: '/activity/fifthAnniversary/detail' },
  { url: '/activity/swapTrade/index' },
  { url: '/activity/kol-incentive-plan' },
  // { url: '/activity/cashback' },
  // { url: '/activity/cashbackDetails' },
  // { url: '/activity/cashbackAssistance' },
  {
    url: '/c2c/trade/creditCardIndex',
    title: 'other_v1_2_2_BuyCryptoWithCredit',
    description: 'other_v1_2_2_GetStartedWithEasy',
    keywords: 'other_v1_2_2_buycryptowithcreditcard',
  },
  { url: '/c2c/trade/CreditCardOrder' },
  // {
  //   url: '/chargeBack',
  //   title: 'other_v1_2_2_CopyTradingCopyingTop',
  //   description: 'other_v1_2_2_ExperienceSeamlessCopyTrading',
  //   keywords: 'other_v1_2_2_copytrading',
  // },
  {
    url: '/chargeBack/OrderBearer/homepage',
    title: 'other_v1_2_2_PortfolioCenter',
    description: 'other_v1_2_2_DiscoverTopPerformanceLeading',
  },
  { url: '/chargeBack/OrderBearer/myBearer' },
  { url: '/chargeBack/OrderBearer/BearerSet' },
  { url: '/chargeBack/OrderBearer/traderLevel' },
  { url: '/chargeBack/orderDocumentary/myDocumentary', description: 'other_v1_2_2_ExploreOurPortfolioCenter' },
  {
    url: '/chargeBack/orderDocumentary/documentarySet',
    title: 'other_v1_2_2_PortfolioCenterCopyTradeSettings',
    description: 'other_v1_2_2_ExploreOurPortfolioCenterForCopyTrading',
  },
  { url: '/chargeBack/OrderBearer/followUpSettings' },
  { url: '/ieo' },
  { url: '/ieo/details' },
  { url: '/ieo/order' },
  {
    url: '/benefitsCenter/home',
    title: 'other_v1_2_2_RewardCenterHotcoin',
    description: 'other_v1_2_2_EarnCryptoRewardsOn',
    keywords: 'other_v1_2_2_cryptorewards',
  },
  { url: '/benefitsCenter/myTask' },
  { url: '/benefitsCenter/myReward' },
  { url: '/benefitsCenter/myReward/taskLog' },
  { url: '/benefitsCenter/contractCoupon' },
  { url: '/pay' },
  { url: '/pay/home' },
  { url: '/pay/transfer' },
  { url: '/pay/collection' },
  { url: '/pay/payRecord' },
  { url: '/orderHome' },
  { url: '/orderHome/coinTradeOrder' },
  { url: '/orderHome/leverOrder' },
  { url: '/orderHome/contractOrder' },
  { url: '/orderHome/wealthManagementRecord' },
  { url: '/orderHome/ledgeBorrowMoneyRecord' },
  { url: '/orderHome/ieoOrder' },
  { url: '/orderHome/transferRecord' },
  { url: '/assetManagement' },
  { url: '/assetManagement/overView' },
  { url: '/assetManagement/home' },
  { url: '/assetManagement/margin' },
  { url: '/assetManagement/swaps' },
  { url: '/assetManagement/financialAccount' },
  { url: '/assetManagement/margin/order/index' },
  { url: '/assetManagement/margin/order/data' },
  { url: '/assetManagement/chargeBackAccount' },
  { url: '/assetManagement/chargeBackAccount/financialLog' },
  { url: '/assetManagement/swaps/finance' },
  { url: '/assetManagement/financial' },
  { url: '/assetManagement/transfer' },
  // { url: '/assetManagement/topup' },
  // { url: '/assetManagement/extract' },
  // { url: '/assetManagement/address' },
  // { url: '/assetManagement/rechargeList' },
  { url: '/assetManagement/coin/profitAnalysis' },
  { url: '/assetManagement/swaps/profitAnalysis' },
  { url: '/userDelete' },
  {
    url: '/vip',
    title: 'other_v1_2_2_HotcoinVIPCenter',
    description: 'other_v1_2_2_BecomeAHotcoinVIP',
    keywords: 'other_v1_2_2_bestcryptotradingplatform',
  },
  // {
  //   url: '/learn/index',
  //   title: 'other_v1_2_2_HotcoinAcademyUnderstanding',
  //   description: 'other_v1_2_2_HotcoinAcademyProvidesComprehensive',
  //   keywords: 'other_v1_2_2_cryptocurrencies',
  // },
  { url: '/learn/list' },
  { url: '/learn/article' },
  { url: '/userfeedback' },
  { url: '/preMarket' },
  { url: '/preMarket/coin' },
  { url: '/preMarket/order' },
  { url: '/sentry' },
  { url: '/sumsubPrev' },
  { url: '/sumsub' },
  { url: '/accessKey' },
  { url: '/benefitsCenter/tradingFundDetails' },
]

module.exports = urls
